import React, { memo, useMemo } from "react";
import { Box, Divider } from "@mui/material";
import { OrderDetails, ProductDetail } from "../../types";
import useBreakpoint, { Breakpoint } from "../../hooks/useBreakpoint";
import Col from "component/layoutComponents/Col/Col";
import Row from "component/layoutComponents/Row/Row";
import Typography from "component/MarketPlace/Typography/Typography";
import OrderedItem from "./OrderedItem";

export interface OrderedListProps {
  orderDetails: OrderDetails;
  onCancelOrderItem?: (product: ProductDetail) => any;
  onMarkOrderItemReceived?: (product: ProductDetail) => any;
  isApprovalPage?: boolean;
  locale: any;
  localeOrderItem: any;
  userMarketplace?: Record<string, any>;
  pendingApprovalDelegatedLocale?: string;
  isLastAccessPage?: boolean;
}

const OrderedList = ({ orderDetails, onCancelOrderItem, onMarkOrderItemReceived, isApprovalPage, locale, localeOrderItem, userMarketplace, pendingApprovalDelegatedLocale, isLastAccessPage = false }: OrderedListProps) => {
  const breakpoint = useBreakpoint();

  const totalQuantity = useMemo(() => {
    const list = orderDetails?.products || [];
    const quantity = list.reduce(
      (total: number, current: { quantity: number }) =>
        total + (current?.quantity || 1),
      0
    );
    return quantity;
  }, [orderDetails]);

  return (
    <>
      {(!isLastAccessPage && (breakpoint >= Breakpoint.md)) && (
        <Row py="6px" px="16px" spacing={{ xs: '16px', md: '32px' }}>
          <Col xs={8} md={7}>
            <Box display="flex" alignItems="center">
              <Typography variant="body2">{locale?.product}&nbsp;</Typography>
              <Typography variant="body2" color="text.secondary">
                ({orderDetails?.products?.length || 0})
              </Typography>
            </Box>
          </Col>
          <Col xs={4} md={2}>
            <Box display="flex" alignItems="center">
              <Typography variant="body2">{locale?.quantity}&nbsp;</Typography>
              <Typography variant="body2" color="text.secondary">({totalQuantity})</Typography>
            </Box>
          </Col>
        </Row>
      )}
      <Divider />
      <Box>
        {orderDetails?.products?.map((productDetail: Record<string, any>) => {
          return (
            <OrderedItem
              key={productDetail?._id}
              productDetail={productDetail}
              onMarkReceived={onMarkOrderItemReceived}
              isApprovalPage={isApprovalPage}
              locale={localeOrderItem}
              userMarketplace={userMarketplace}
              assigned_approver={orderDetails?.approval?.assigned_approver}
              approval_status={orderDetails?.approval?.approval_status}
              pendingApprovalDelegatedLocale={pendingApprovalDelegatedLocale}
            />
          );
        })}
      </Box>
    </>
  );
};

export default memo(OrderedList);
